import React, { useState } from "react";
import AddGroup from "./addGroup";
import GroupItem from "./groupItem";

export default function GroupsCell({ groups, carId, modal, mergeParams, organization }) {
    const [groupsCount, setGroupsCount] = useState(groups.length);

    const incrementGroupsCount = () => setGroupsCount((prev) => prev + 1);
    const decrementGroupsCount = () => setGroupsCount((prev) => prev - 1);
    const addGroup = (carId) => {
        modal({
            name: "default",
            title: "Добавление группы",
            windowMod: "sm",
            CustomBody: AddGroup,
            bodyData: {
                carId,
                refreshData: () => {
                    incrementGroupsCount();
                    mergeParams({});
                },
            },
        });
    };

    return (
        <>
            {groups.map((group) => (
                <GroupItem
                    key={group.id}
                    group={group}
                    modal={modal}
                    carId={carId}
                    refreshData={() => mergeParams({})}
                    onRemove={decrementGroupsCount}
                    useUniqueUsersGroups={organization?.useUniqueUsersGroups}
                />
            ))}
            {(!organization?.useUniqueUsersGroups || groupsCount === 0) && (
                <button className="btn btn-outline-dark btn-xs" onClick={() => addGroup(carId)}>
                    <i className="icon-uEA01-add font-size-8" /> Добавить группу
                </button>
            )}
        </>
    );
}
